<template>
    <div style="overflow-x:hidden;">
        <!-- <BannerStatic :ban="wWidth<768?banner[1]:banner[0]" style="height: 600px;"></BannerStatic> -->
        <Intro class="px-xs-32 intro-over-banner"></Intro>
        <!-- <Range :bg="require('@/assets/bgRange.png')"></Range> -->
        <!-- <Num></Num> -->
        <Range :bg="wWidth<768?require('@/assets/phone/abMapFont.png'):require('@/assets/d_map.gif')"></Range>
        <Honor class="px-xs-32"></Honor>
    </div>
</template>

<script>
// import BannerStatic from '@/components/header/bannerStatic.vue'
import Intro from '@/components/about/intro.vue'
import Range from '@/components/about/range.vue'
import Honor from '@/components/about/honor.vue'
import Num from '../components/home/num.vue'


export default {
    components:{
        // BannerStatic,
        Intro,
        Range,
        Honor,
        Num,
    },
    data(){
        return{
            banner: [require('@/assets/employ/logo1.1.png'),require('@/assets/phone/bannerAb.png')],
            wWidth: window.screen.width
        }
    }
    
}
</script>

